// extracted by mini-css-extract-plugin
export default {"app":"routes_app__LWaRx"};